import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-charcoal text-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="md:col-span-1">
            <img src="/images/logo.jpg" alt="Du Sourire à la Fourchette" className="h-16 w-auto mb-4 rounded-xl" />
            <p className="text-cream/60 leading-relaxed text-sm">
              Traiteur à domicile passionné par la gastronomie et le partage. Créons ensemble des moments inoubliables.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-base font-bold mb-4 text-gold">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => scrollToSection('hero')} className="text-cream/60 hover:text-gold transition-colors">Accueil</button></li>
              <li><button onClick={() => scrollToSection('services')} className="text-cream/60 hover:text-gold transition-colors">Services</button></li>
              <li><button onClick={() => scrollToSection('gallery')} className="text-cream/60 hover:text-gold transition-colors">Galerie</button></li>
              <li><button onClick={() => scrollToSection('booking')} className="text-cream/60 hover:text-gold transition-colors">Réserver</button></li>
            </ul>
          </div>

          {/* Pages */}
          <div>
            <h3 className="text-base font-bold mb-4 text-gold">Pages</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/prestations" className="text-cream/60 hover:text-gold transition-colors">Prestations</Link></li>
              <li><Link to="/avis" className="text-cream/60 hover:text-gold transition-colors">Avis clients</Link></li>
              <li><Link to="/blog" className="text-cream/60 hover:text-gold transition-colors">Blog & Conseils</Link></li>
              <li><button onClick={() => navigate('/mentions-legales')} className="text-cream/60 hover:text-gold transition-colors">Mentions légales</button></li>
              <li><button onClick={() => navigate('/confidentialite')} className="text-cream/60 hover:text-gold transition-colors">Confidentialité</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-base font-bold mb-4 text-gold">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" />
                <a href="tel:+33663894103" className="text-cream/60 hover:text-gold transition-colors">+33 6 63 89 41 03</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" />
                <a href="mailto:dusourirealafourchette@gmail.com" className="text-cream/60 hover:text-gold transition-colors break-all">dusourirealafourchette@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" />
                <span className="text-cream/60">Solliès-Pont, Var (83)</span>
              </li>
            </ul>
            <div className="mt-5 flex gap-3">
              <a href="https://www.facebook.com/du.sourire.a.la.fourchette" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-cream/10 hover:bg-gold/20 rounded-full flex items-center justify-center transition-all hover:scale-110">
                <Facebook className="w-4 h-4 text-cream" />
              </a>
              <a href="https://www.instagram.com/dusourirealafourchette/" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 bg-cream/10 hover:bg-gold/20 rounded-full flex items-center justify-center transition-all hover:scale-110">
                <Instagram className="w-4 h-4 text-cream" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4 text-cream/40 text-sm">
          <p>© {new Date().getFullYear()} Du Sourire à la Fourchette. Tous droits réservés.</p>
          <div className="flex gap-6">
            <button onClick={() => navigate('/mentions-legales')} className="hover:text-gold transition-colors">Mentions légales</button>
            <button onClick={() => navigate('/confidentialite')} className="hover:text-gold transition-colors">Politique de confidentialité</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
